<template>
    <div>
        <div class="card card-xxl-stretch card-bordered">
            <div class="card-header">
                    <div class="card-title">
                        {{ $t('bank_detail_list') }}
                    </div>
                </div>
            <div class="card-body">
                <div class="d-flex flex-stack flex-wrap mb-5">
                    <div class="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
                        <button type="button" class="btn btn-sm btn-light btn-active-success me-3" ref="btnAddItem" @click="this.openBankDetailModal('add')" data-bs-toggle="modal" data-bs-target="#kt_modal_add_bank_detail">
                            <span class="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1"
                                        transform="rotate(-90 11.364 20.364)" fill="currentColor"></rect>
                                    <rect x="4.36396" y="11.364" width="16" height="2" rx="1"
                                        fill="currentColor">
                                    </rect>
                                </svg>
                            </span>
                            {{ $t('add_new') }}
                        </button>
                        <button type="button" class="btn btn-sm btn-light btn-active-primary me-3" @click="this.openBankDetailModal('edit')" data-bs-toggle="modal" data-bs-target="#kt_modal_add_bank_detail"
                            :disabled="isBankDetailButtonDisabled == null || isBankDetailButtonDisabled == undefined">
                            <span class="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"/>
                                        <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"/>
                                    </svg>
                            </span>
                            {{ $t('edit') }}
                        </button>
                        <button type="button" class="btn btn-sm btn-light btn-active-warning me-3" @click="this.deleteBankDetailItem()" 
                            :disabled="isBankDetailButtonDisabled == null || isBankDetailButtonDisabled == undefined">
                            <span class="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                </svg>
                            </span>
                            {{ $t('remove') }}
                        </button>
                        <button type="button" class="btn btn-sm btn btn-light btn-active-danger me-3" @click="this.deleteBankDetailItem(true)" 
                            :disabled="this.accountBankDetails.length == 0">
                            <span class="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                </svg>
                            </span>
                            {{ $t('remove_all') }}
                        </button>
                    </div>
                </div>
                <div id="kt_datatable_example_1_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div class="table-responsive">
                        <DxDataGrid id="gridContainer" :key="$i18n.locale" :show-borders="true" 
                                key-expr="id" 
                                :data-source="accountBankDetails" 
                                :allow-column-reordering="true"  
                                :allow-column-resizing="true" 
                                :column-auto-width="true" 
                                :row-alternatin-enabled="true"
                                :hover-state-enabled="true" 
                                :show-row-lines="true" 
                                @exporting="this.$onExporting($event , 'Account-factor-list')">

                                <DxFilterRow :visible="true"/>
                                <DxHeaderFilter :visible="true"/>
                                <DxGroupPanel :visible="true"/>      
                                <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                <DxPaging :page-size="pageSize"/>
                                <DxPager :visible="true" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/>    
                                <DxSearchPanel :visible="true"/>

                                <DxScrolling
                                    mode="virtual"
                                    row-rendering-mode="virtual"
                                />
                                <DxColumn data-field="isSelected" caption="#" :width="100" :allow-filtering="false" alignment="center" cell-template="is-selected-cell-template" :allow-exporting="false"/>
                                <!-- <DxColumn data-field="bank_detail_id" :caption="$t('general_account_bank')" cell-template="general-bank-cell-template" :allowEditing="false"/> -->
                                <DxColumn data-field="bank_account_name" :caption="$t('general_account_bank')" alignment="left" cell-template="bank_account_name-cell-template"/>
                                <DxColumn data-field="short_code" :caption="$t('short_code')" alignment="left" cell-template="short_code-cell-template"/>
                                <DxColumn data-field="account_number" :caption="$t('account_number')" alignment="left" cell-template="account_number-cell-template"/>
                                <DxColumn data-field="iban" :caption="$t('iban')" alignment="left" cell-template="iban-cell-template"/>
                                <DxColumn data-field="created_by" :caption="$t('created_by')" alignment="left" cell-template="created_by-cell-template"/>
                                
                                <template #is-selected-cell-template="{ data }"> 
                                    <span>
                                        <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                            <input class="form-check-input" type="checkbox" v-model="data.data.isSelected" @change="this.onSelectBankDetailItem(data.data)" />
                                        </div>
                                    </span>
                                </template>
                                <!-- <template #general-bank-cell-template="{ data }"> 
                                    <span>
                                        {{ getBankName(data.data.bank_detail_id) }}
                                    </span>
                                </template> -->
                                <template #bank_account_name-cell-template="{ data }"> 
                                    <span>
                                        {{ data.data.bank_account_name }}
                                    </span>
                                </template>
                                <template #short_code-cell-template="{ data }"> 
                                    <span>
                                        {{ data.data.short_code }}
                                    </span>
                                </template>
                                <template #account_number-cell-template="{ data }"> 
                                    <span>
                                        {{ data.data.account_number }}
                                    </span>
                                </template>
                                <template #iban-cell-template="{ data }"> 
                                    <span>
                                        {{ data.data.iban }}
                                    </span>
                                </template>
                                <template #created_by-cell-template="{ data }"> 
                                    <span>
                                        {{ data.data.created_by }}
                                    </span>
                                </template>
                        </DxDataGrid>
                    </div>
                </div>
            </div>
        </div>
        <!-- Add Account Factor -->
        <div class="modal fade" id="kt_modal_add_bank_detail" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header bg-primary">
                        <h2 class="modal-title fw-bolder col-md-10 text-white" v-if="bankDetailModalType == 'add'">{{ $t('add_new_bank_detail') }}</h2>
                        <h2 class="modal-title fw-bolder col-md-10 text-white" v-if="bankDetailModalType == 'edit'">{{ $t('edit_bank_detail') }}</h2>
                        <div class="btn btn-icon btn-sm btn-active-icon-primary"
                            data-bs-dismiss="modal" aria-label="Close" ref="closeAddAccountBankDetailModal">
                            <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="card">
                            <div class="card-body py-3">                                
                                <div id="kt_policy_tab_1" class="tab-pane fade show active" role="tabpanel">
                                    <div class="fv-row row mb-7">
                                        <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'bank_account_name'">{{ $t('general_bank_name') }}
                                            </label>
                                            <input type="text" class="form-control" name="bank_account_name" v-model="modalForm.bank_account_name" v-custom>
                                        </div>
                                        <div class="col-lg-6">
                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'short_code'">{{ $t('short_code') }}</label>
                                            <input type="text" class="form-control" name="short_code" v-model="modalForm.short_code" v-custom>
                                        </div>
                                        <div class="col-lg-6">
                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'account_number'">{{ $t('account_number') }}</label>
                                            <input type="text" class="form-control" name="account_number" v-model="modalForm.account_number" v-custom>
                                        </div>
                                        <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'IBAN'">{{ $t('iban') }}</label>
                                            <input type="text"  :class="{'is-invalid':ibanError}" :maxlength="maxLength" class="form-control" @input="validateIban()" name="iban" v-model="modalForm.iban" v-custom>
                                            <p v-if="ibanError" class="error-message">{{ ibanError }}</p>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer row mx-0">
                        <div class="d-grid gap-2">
                            <div class="btn-group"> 
                                <div class="col-lg-12">
                                    <div class="d-grid gap-2">
                                        <button type="button" class="btn btn-success btn-lg" v-if=" bankDetailModalType == 'add'" :disabled="this.ibanErrorControl"
                                            @click="saveData()">
                                            <span class="indicator-label">{{ $t('save') }}</span> 
                                        </button>
                                        <button type="button" class="btn btn-primary btn-lg" v-if="bankDetailModalType == 'edit'" :disabled="this.ibanErrorControl"
                                            @click="editDetails()">
                                            <span class="indicator-label">{{ $t('update') }}</span> 
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxPaging, DxPager, DxColumn, DxScrolling } from 'devextreme-vue/data-grid';
export default {
    name: 'AccountBankDetails',
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxPaging, DxPager, DxColumn, DxScrolling
    },
    data() {
        return {
            pageSize: 20,
            accountBankDetails: [],
            parentAccountId: this.$parent.form.id,
            bankList:[],
            modalForm: {
                id: null,
                bank_detail_id: '-1',
                short_code: null,
                account_number: null,
                iban: null,
                bank_account_name: null,
            },
            ibanError: null,
            ibanData: {
                AL: 28, AD: 24, AT: 20, AZ: 28, BH: 22, BE: 16, BA: 20, BR: 29, BG: 22,
                CR: 21, HR: 21, CY: 28, CZ: 24, DK: 18, DO: 28, EE: 20, FO: 18, FI: 18,
                FR: 27, GE: 22, DE: 22, GI: 23, GR: 27, GL: 18, GT: 28, HU: 28, IS: 26,
                IE: 22, IL: 23, IT: 27, JO: 30, KZ: 20, KW: 30, LV: 21, LB: 28, LI: 21,
                LT: 20, LU: 20, MT: 31, MR: 27, MU: 30, MC: 27, MD: 24, ME: 22, NL: 18,
                NO: 15, PK: 24, PS: 29, PL: 28, PT: 25, RO: 24, SM: 27, SA: 24, RS: 22,
                SK: 24, SI: 19, ES: 24, SE: 24, CH: 21, TN: 24, TR: 26, AE: 23, GB: 22,
                VG: 24,
            },
            ibanErrorControl: false,
            maxLength: null,
            bankDetailModalType: 'add',
        }
    },
    computed:{
        isBankDetailButtonDisabled() {
            return this.accountBankDetails.find(item => item.isSelected == true ); 
        },
        showPageSizeSelector() {
            return this.accountBankDetails.length > this.pageSize;
        },
        pageSizes() {
            let arr = [];
            let x = 1;
            let loop = this.accountBankDetails.length / this.pageSize;
            for (let i = 1; i <= loop && i <= 5; i++) {
                arr.push(this.pageSize * x);
                x++;
            }
            if(loop > 5) arr.push(1000);
            if(loop > 1) arr.push('all');
            return arr;
        }
    },
    methods: {        
        openBankDetailModal(modalType) {
            this.clearBankDetailForm();
            this.bankDetailModalType = modalType;
            if(modalType == 'edit') {
                this.accountBankDetails.forEach(element => {
                    if(element.isSelected) {
                        this.modalForm.id = element.id;
                        this.modalForm.account_number = element.account_number;
                        this.modalForm.bank_detail_id = element.bank_detail_id;
                        this.modalForm.iban = element.iban;
                        this.modalForm.short_code = element.short_code;
                        this.modalForm.bank_account_name = element.bank_account_name;
                    }
                });
            }
        },
        getData() {
            const parameters = {
                session_id: this.$getUser().session_id,
                parent_account_id : this.parentAccountId,
            };  
            axios.post('api/CompanyAccounts/GetAccountBankDetail', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                this.accountBankDetails = response.data;
            }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        onSelectBankDetailItem(item) {
            this.accountBankDetails.forEach((value) => { 
                if (item.id !== value.id) {
                    value.isSelected = false;
                }
            });
        },
        deleteBankDetailItem(isDeleteAll){
            let detailId = null;
            this.accountBankDetails.forEach((item) => {
                if (item.isSelected) {
                    detailId = item.id;
                }
            });
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_remove_this_item'),
                confirmButtonColor: "#f1416c",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('delete'),
                icon: 'info'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    const parameters = {
                        session_id: this.$getUser().session_id,
                        parent_account_id: this.parentAccountId,
                        is_delete_all: isDeleteAll ? 1 : 0,
                        id: detailId,
                    }; 
                    axios.post('/api/CompanyAccounts/DeleteAccountBankDetail', parameters, {'Content-Type': 'application/json'})
                    .then((response) => {
                        if(response.data.error == null || response.data.error == '' || response.data.error == undefined){
                        this.getData();
                        } 
                    }) 
                    .catch((error) => {
                        console.error(error);
                        this.Progress.finish();
                    });
                }
            });
        },
        getBankList(){
            const parameters = {
            session_id: this.$getUser().session_id,
            list_types: [
                {
                    list_type: 2,
                    list_name: "bank_list"
                }
            ],
            list_name: ["branch", "account_setting", "currency"],
            account_type: 4 // yalnızca account settings listesi çekilecek ise gerekli
            };
            axios.post('/api/Helper/GetMultiLists', parameters, {'Content-Type': 'application/json'})
            .then((response) =>{
                this.bankList = response.data.bank_list;
            })
        },
        saveData() {
            const params = {
                session_id: this.$getUser().session_id,
                parent_account_id: this.parentAccountId,
                bank_detail_id: this.modalForm.bank_detail_id,
                short_code: this.modalForm.short_code,
                account_number: this.modalForm.account_number,
                iban: this.modalForm.iban,
                bank_account_name: this.modalForm.bank_account_name,
            };
            axios.post('api/CompanyAccounts/CreateAccountBankDetail',params,{'Content-Type' : 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');  
                    this.accountBankDetails = response.data;
                    this.$refs.closeAddAccountBankDetailModal.click();
                    this.clearBankDetailForm();
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        editDetails() {
            const params = {
                session_id : this.$getUser().session_id,
                id: this.modalForm.id,
                bank_detail_id: null,
                short_code: this.modalForm.short_code,
                account_number: this.modalForm.account_number,
                iban: this.modalForm.iban,
                bank_account_name: this.modalForm.bank_account_name,
            };
            axios.post('api/CompanyAccounts/UpdateAccountBankDetail',params,{'Content-Type' : 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.$swal(this.$t('success'), this.$t('data_update_succesfully'), 'success');  
                    this.accountBankDetails = response.data;
                    this.$refs.closeAddAccountBankDetailModal.click();
                    this.clearBankDetailForm();
                }
            })
            .catch((error) => {
                console.error(error);
            });
            
        },
        clearBankDetailForm() {
            this.modalForm = {
                id: null,
                bank_detail_id: '-1',
                short_code: null,
                account_number: null,
                iban: null,
                bank_account_name: null
            };
        },
        validateIban() {
            const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;
            this.modalForm.iban = this.modalForm.iban.replace(/\s+/g, '').toUpperCase();
            if (this.modalForm.iban.trim() === '') {
                this.ibanError = null;
                this.ibanErrorControl = false;
                this.maxLength = this.modalForm.iban.length;
                return
            }
            if (!ibanRegex.test(this.modalForm.iban)) {
                this.ibanError = "Enter a valid IBAN format.";
                this.ibanErrorControl = true;
                return;
            }
            const countryCode = this.modalForm.iban.substring(0, 2);
            if (!this.ibanData[countryCode]) {
                this.ibanError = `An unsupported country code: ${countryCode}`;
                this.ibanErrorControl = true;
                return;
            }
            const expectedLength = this.ibanData[countryCode];
            if (this.modalForm.iban.length !== expectedLength) {
                this.ibanError = `${countryCode} IBAN must be ${expectedLength} characters long.`;
                this.ibanErrorControl = true;
                this.maxLength = expectedLength;
                return;
            }
            if (this.modalForm.iban.length == expectedLength) {
                this.modalForm.iban = this.modalForm.iban.slice(0, expectedLength); 
                this.ibanError = '';
                this.ibanErrorControl = false;
                this.maxLength = expectedLength; 
            }
            this.ibanError = null;
            this.ibanErrorControl = false;
        }
    },
    created() {
        this.getData();
        this.getBankList();
    }
}
</script>